export class JiraTask {
  title: string;
  description: string;
  userEmail: string;
  issueType: string;
  sendConfirmationMail: boolean;
  cellNumber :string;
  cardDigits :string;
  deviceMakeAndModel: string;
}
